var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPodcast105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M29.81 90.782a.5.5 0 0 0 .51-.86 43.5 43.5 0 1 1 44.361 0 .5.5 0 0 0 .51.86 44.5 44.5 0 1 0-45.38 0Zm-.167-21.39a.5.5 0 0 0 .631-.741 27.5 27.5 0 1 1 44.452 0 .502.502 0 0 0 .808.59 28.5 28.5 0 1 0-46.068 0 .5.5 0 0 0 .177.15Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M47.778 55.572a8.5 8.5 0 0 0 4.722 1.432 8.51 8.51 0 0 0 8.5-8.5 8.5 8.5 0 1 0-13.222 7.068Zm.555-13.304a7.5 7.5 0 0 1 4.167-1.264 7.508 7.508 0 0 1 7.5 7.5 7.5 7.5 0 1 1-11.667-6.236ZM42.5 97.004h20a.5.5 0 0 0 .5-.466l1.43-21.467a8.5 8.5 0 0 0-8.48-9.066h-6.898a8.472 8.472 0 0 0-3.769.88 8.499 8.499 0 0 0-4.713 8.184L42 96.538a.5.5 0 0 0 .5.466Zm19.532-1H42.968l-1.4-21.001a7.499 7.499 0 0 1 7.484-7.999h6.898a7.508 7.508 0 0 1 7.482 7.999l-1.4 21.001Z",
  clipRule: "evenodd"
})));
export { SvgPodcast105 as ReactComponent };
export default __webpack_public_path__ + "a5bedefa58b9499515b64c556f9029bd.svg";